<template lang="pug">
.custom-dropdown(v-if="showList")
    aiq-select(
        :placeholder = "placeholder",
        v-model="value",
        :suffix-icon="Icon.CaretBottom"
        :disabled="viewMode"
        @change="onSelectChange"
        )
        aiq-option(v-for="item in htmlList",
                    :key="item.value",
                    :label="item.value",
                    :value="item.value")
            .option-list
                span.label-text(v-html="item.label" @click="handleLabelClick(item)")
                .btn-list(v-if="item.value")
                    aiq-button.btn(size="small")(@click="handleOpen('view', item.value)") View
                    aiq-button.btn(size="small")(@click="handleOpen('edit', item.value)") Edit
</template>
<script>
import get from 'lodash/get';
export default {
  name: 'custom-dropdown',
  data() {
    return {
      value: '',
    };
  },
  emits: ['change', 'open'],
  props: {
    placeholder: {
      type: String,
      default: 'Select',
    },
    htmlList: {
      type: Array,
      default: () => [],
    },
    viewMode: {
      type: Boolean,
      default: false,
    },
    itemValue: {
      type: String,
      default: '',
    },
    itemIndex: {
      type: Number,
      default: 0,
    },
  },
  watch: {
    itemValue() {
      this.value = this.itemValue;
    },
  },
  mounted() {
    this.value = this.itemValue;
  },
  computed: {
    showList() {
      const list = get(this, 'htmlList', []);
      return list.length > 0;
    },
  },
  methods: {
    onSelectChange(value) {
      this.$emit('change', value, this.itemIndex);
    },
    handleOpen(type, value) {
      this.$emit('open', { type, value, index: this.itemIndex });
    },
    handleLabelClick(item) {
      if (!item.value) {
        this.$emit('open', { type: 'add', index: this.itemIndex });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "src/styles/aiq-variables.scss";

:deep(.add-new) {
  display: block;
  width: 100%;
  box-sizing: border-box;
}

.md-theme-agentiq .el-select-dropdown .el-select-dropdown__item.is-selected:hover {
  background-color: var(--aiq-table-border) !important;
}
.btn-list {
    float: right;
    border-width: 1px;
}
.btn {
    border-radius: 100px;
}
.option-list {
    display: flex;
    justify-content: space-between;
    width: 100%
}
.label-text {
    padding-top: 5px;
    flex: 1;
}
</style>
